// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getDocType = createAsyncThunk('docTypeSliceData/getDocType', async () => {
    try {
        let response = await axios.get('/DocType', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getDocTypeoption = createAsyncThunk('docTypeSliceData/getDocTypeoption', async () => {
    try {
        let response = await axios.get('/DocType?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const deleteDocType = createAsyncThunk('docTypeSliceData/deleteDocType', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/DocType/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'DocType deleted successfully.');
        await dispatch(getDocType());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createDocType = createAsyncThunk('docTypeSliceData/createDocType', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/DocType', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'DocType added succesfully.');
        await dispatch(getDocType());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateDocType = createAsyncThunk('docTypeSliceData/updateDocType', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/DocType/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'DocType updated succesfully.');
        await dispatch(getDocType());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateDocTypeStatus = createAsyncThunk('docTypeSliceData/updateDocTypeStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/DocType/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status Updated Succesfully');
        await dispatch(getDocType());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const docTypeSlice = createSlice({
    name: 'docTypeSliceData',
    initialState: {
        docType: [],
        docTypeoption: []
    },
    extraReducers: (builder) => {
        builder.addCase(getDocType.fulfilled, (state, action) => {
            state.docType = action?.payload;
            return;
        });
        builder.addCase(getDocTypeoption.fulfilled, (state, action) => {
            state.docTypeoption = action?.payload;
            return;
        });
    }
});

export default docTypeSlice.reducer;
